export default ( DB ) => {
    if ( DB.endsWith('-customers') ) return 'customers'
    switch ( DB ) {
        case 'surveys': return 'campaigns';
        case 'jb-ads': return 'ads';
        case 'refer-links': return 'referrals'
    }
    return DB;    
}